import { render, staticRenderFns } from "./PredixCastingResultsPlaceholder.vue?vue&type=template&id=6c091538"
import script from "./PredixCastingResultsPlaceholder.vue?vue&type=script&lang=js"
export * from "./PredixCastingResultsPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports